import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { OffboardingSettings } from '../../shared/models/OffboardingSettings';
import { EmployeeService } from '../../shared/service/employee.service';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS, MatTableDataSource, MatDialog, MatPaginator, MatSort } from '@angular/material';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../shared/service/user.service';
import { Router } from '@angular/router';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../../shared/components/confirm-dialog/confirm-dialog.component';
import { isNullOrUndefined } from 'util';
import { dropObj } from '../offboarding-feedback/offboarding-feedback.component';



@Component({
  selector: 'app-offboarding-settings',
  templateUrl: './offboarding-settings.component.html',
  styleUrls: ['./offboarding-settings.component.css']
})



export class OffboardingSettingsComponent implements OnInit {
  date: Date;
  todayDate: Date;
  offBoardSet: OffboardingSettings;
  nameCheck: OffboardingSettings[] = [];
  OffboardingSettings: FormGroup;
  error: any;
  fbList: any[];
  filteredList: any[] = [];
  employeeList: any[] = [];
  tempdropdownListIT: any[] = [];
  tempdropdownListAdmin: any[] = [];
  OffboardingSettingsForm: FormGroup;
  feedback: string;
  contact: string;
  LoginEmpCode: any;
  contactList: OffboardingSettings[] = [];
  dataSourceFTE: any;
  result: any;
  EmployeeCode: any;
  employeeId: FormControl;
  settingsListIT: any[] = [];
  settingsListAdmin: any[] = [];
  loader: boolean;
    currentDept: any;



  constructor(private emp_Svc: EmployeeService, private toastr: ToastrService, public dialog: MatDialog, private userService: UserService, private router: Router) {
    this.date = new Date();
    this.todayDate = new Date();
    this.dataSourceFTE = new MatTableDataSource;
  }



  displayedColumns: string[] = ['FeedbackType', 'EmpCode', 'Name', 'Contacts', 'Delete'];
  @ViewChild('paginator', { static: false }) paginator: MatPaginator;
  @ViewChild('sort', { static: false }) sort: MatSort;
  ngOnInit() {
    this.employeeId = new FormControl();
    this.offBoardSet = new OffboardingSettings();
    this.getEmployeeList();
    this.getAllContacts();
    this.FormInitialization();
    this.loadFeedbacktype();
    this.LoginEmpCode = this.userService.getEmpCode().toString();
  }



  FormInitialization() {
    this.OffboardingSettingsForm = new FormGroup({
      Feedback: new FormControl(),
      Contacts: new FormControl()
    });
  }



  applyFilter(filterValue: string) {
    this.dataSourceFTE.filter = filterValue.trim().toLowerCase();
  }



  loadFeedbacktype() {
    this.emp_Svc.getAllFeedbacks().subscribe((data: any[]) => {
      this.fbList = data;
    }, error => this.error = error);
  }



  getEmployeeList() {
    this.emp_Svc.getAllEmployees().subscribe((data: any[]) => {
      this.employeeList = data;
      this.settingsListIT = this.employeeList.filter(x => x.Department == "IT");
      this.settingsListAdmin = this.employeeList.filter(x => x.Department == "Admin");
        this.settingsListIT.forEach(el => {
          let item = new dropObj();
          item.DisplayName = el.EmpCode + "-" + el.FirstName + "-" + el.Email;
          this.tempdropdownListIT.push(item);
        });
        this.settingsListAdmin.forEach(el => {
          let item = new dropObj();
          item.DisplayName = el.EmpCode + "-" + el.FirstName + "-" + el.Email;
          this.tempdropdownListAdmin.push(item);
        });

    }, error => this.error = error);
  }
  changeList(event) {
    this.currentDept = event;
    if (event == "IT") {
      this.filteredList = this.tempdropdownListIT;
      this.EmployeeCode = "";
    }
    else if (event == "Admin") {
      this.filteredList = this.tempdropdownListAdmin;
      this.EmployeeCode = "";
    }
    else {
      this.filteredList = [];
    }
  }


  saveContacts() {
    window.scrollTo(0, 0);
    this.loader = true;
    if (this.OffboardingSettingsForm.invalid || this.EmployeeCode == "" || isNullOrUndefined(this.EmployeeCode)) {
      this.loader = false;
      this.toastr.warning("Please fill the required fields.");
      return;
    }
    if (!isNullOrUndefined(this.EmployeeCode)) {
      if ((this.EmployeeCode != "")) {
        var settingscheckinListIT = this.tempdropdownListIT.filter(x => x.DisplayName == this.EmployeeCode);
        var settingscheckinListAdmin = this.tempdropdownListAdmin.filter(x => x.DisplayName == this.EmployeeCode);
        if (settingscheckinListIT.length == 0 && settingscheckinListAdmin.length==0) {
          this.loader = false;
          this.toastr.warning("Please select an Email from dropdown.");
          this.EmployeeCode = "";
          return;
        }
      }
    }

    var id = this.EmployeeCode.split("-");
    this.offBoardSet.Contacts = id[2];
    this.offBoardSet.EmpCode = id[0];
    this.offBoardSet.EmpName = id[1];
    this.offBoardSet.ModifiedBy = this.LoginEmpCode;
    for (var i = 0; i < this.contactList.length; i++) {
      if (this.contactList[i].Contacts.toLowerCase() == this.offBoardSet.Contacts.toLowerCase()) {
        this.contactList[i].duplicateContact = true;
      }
      else
        this.contactList[i].duplicateContact = false;
    }

    var checkduplicate = this.contactList.filter(x => x.duplicateContact == true);
    if (checkduplicate.length == 0) {
      this.emp_Svc.saveallcontacts(this.offBoardSet).subscribe((data: any) => {
        if (data.ErrorType == "Exception") {
          this.loader = false;
          this.toastr.warning(data.ErrorMsg);
        }
        else {
          this.toastr.success("Saved Successfully.");
          this.loader = false;
          this.EmployeeCode = "";
          this.getAllContacts();
        }
      }, error => this.toastr.warning(error));
    }
    else {
      this.toastr.warning("Email ID already exists.");
      this.loader = false;
      this.EmployeeCode = "";
    }
  }



  getAllContacts() {
    this.emp_Svc.getAllContacts().subscribe((data: any) => {
      this.contactList = data;
      this.dataSourceFTE.data = this.contactList;
      this.dataSourceFTE.paginator = this.paginator;
    }, error => this.error = error);
  }



  ResetData() {
    this.OffboardingSettingsForm.reset();
  }



  Cancel() {
    this.router.navigateByUrl("/Offboardinglist");
  }
  doFilter() {
    if (!isNullOrUndefined(this.EmployeeCode)) {
      if (this.currentDept == "IT") {
        this.filteredList = this.filter(this.tempdropdownListIT);
      }
      else if (this.currentDept == "Admin") {
        this.filteredList = this.filter(this.tempdropdownListAdmin);
      }
    }
  }
  filter(values) {
    return values.filter(value => value.DisplayName.toLowerCase().includes(this.EmployeeCode.toLowerCase()));
  }


  deleteEmployeeContact(val) {
    const message = `Are you sure to delete this record?`;
    var deleteType = "Record";
    const dialogData = new ConfirmDialogModel(" ", message, deleteType);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "500px",
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      // console.log(dialogResult);
      if (dialogResult) {
        window.scrollTo(0, 0);
        this.loader = true;
        this.emp_Svc.DeleteOffboardingSettings(val).subscribe(data => {
          this.toastr.success("Deleted Successfully.");
          this.loader = false;
          this.getAllContacts();
        },
          error => this.error = error
        );
      }
    }, error => { this.result = error; });
  }
}
















